module.exports = __webpack_public_path__ + "static/media/logoLogin.405a7598.png";